module.exports = __webpack_public_path__ + "img/image-thumb-12.b41c02e2.jpg";